
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: () => false,
    },
     items: {
      type: Array,
      default: () => [{
          label: 'Profiel',
          path: '/profiel',
        }, {
          label: 'Uitloggen',
          action: 'logout',
        },
      ],
    },
  },
}
